import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    LookupFieldResult,
    LookupObject,
    SystemEntity,
} from '@wdx/clmi/clmi-swagger-gen';
import { ContextualDataContext } from '@wdx/clmi/api-services/models';
import { Observable } from 'rxjs';
import { ApiConfigService } from '../api-config.service';
import { BaseApiService } from '../base-api.service';

interface ContextualSelectBody {
    search?: string;
    lookups: Array<LookupFieldResult | LookupObject>;
    context?: ContextualDataContext[];
}

@Injectable({ providedIn: 'root' })
export class LookupApiService extends BaseApiService {
    constructor(http: HttpClient, apiConfig: ApiConfigService) {
        super(http, apiConfig);
    }

    getLookup(
        lookupSource: string,
        searchText?: string,
        entityId?: string,
        entityType?: SystemEntity,
    ): Observable<LookupFieldResult[]> {
        const search = searchText
            ? {
                  search: searchText,
              }
            : {};
        return this.get<LookupFieldResult[]>(
            `lookup/${lookupSource.toLowerCase()}`,
            {
                params: {
                    ...search,
                    ...(entityId ? { entityId } : {}),
                    ...(entityType ? { entityType } : {}),
                },
            },
        );
    }

    getContextualLookup(
        lookupSource: string,
        lookups: Array<LookupFieldResult | LookupObject>,
        search?: string,
        context?: ContextualDataContext[],
    ): Observable<LookupFieldResult[]> {
        const transformedLookups = lookups.map((lookup) => ({
            id: lookup.id,
            lookupType: lookup.lookupType,
        }));

        return this.post<LookupFieldResult[], ContextualSelectBody>(
            `lookup/${lookupSource.toLowerCase()}`,
            {
                search,
                lookups: transformedLookups,
                ...(context ? { context } : {}),
            },
        );
    }
}
